
export default {
    data() {
        return {
            form: {
                golongan_darah: '',
                rhesus: '',
                komponen_id: null,
                jumlah: 0,
                tipe_transaksi: '',
                keterangan: ''
            },
            form_edit: {
                id_transaksi: '',
                golongan_darah: '',
                rhesus: '',
                komponen_id: null,
                jumlah: 0,
                tipe_transaksi: '',
                keterangan: ''
            },
            list_data: [],
            list_komponen: [],

            page_first: 1,
            page_last: 0,
            page_limit: 10,
            jml_data: 0,
            total_data: 0,
            cari_value: '',

            mdl_add: false,
            btn_add: false,
            mdl_edit: false,
            btn_edit: false,

            mdl_hapus: false,      // modal konfirmasi hapus
            btn_hapus: false,      // loading untuk tombol hapus
            hapus_target: null,
            filter: {
                komponen_id: '',
                golongan_darah: '',
                tipe_transaksi: ''
            }

        }
    },
    methods: {

        getView() {
            const query = new URLSearchParams({
                page: this.page_first,
                limit: this.page_limit,
                cari_value: this.cari_value || '',
                komponen_id: this.filter.komponen_id || '',
                golongan_darah: this.filter.golongan_darah || '',
                tipe_transaksi: this.filter.tipe_transaksi || ''
            }).toString()

            fetch(this.$store.state.url.TRANSAKSI + "view?" + query, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.list_data = res_data.data || []
                        this.total_data = res_data.total_data || 0
                        this.page_last = res_data.total_pages || 1
                        this.jml_data = this.list_data.length
                        // jaga-jaga kalau page_current > page_last setelah filter/cari
                        if (this.page_first > this.page_last) this.page_first = this.page_last || 1
                    } else {
                        this.$q.notify({ type: 'negative', message: res_data.message || 'Gagal memuat data transaksi darah' })

                    }
                })
                .catch(err => {
                    console.error('Error fetching transaksi:', err)
                    this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat data transaksi' })
                })
        },

        getKomponen() {
            fetch(this.$store.state.url.KOMPONEN + "view", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({})
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_komponen = res_data.data || []
                })
                .catch(err => console.error("Error getKomponen:", err))
        },



        addData() {
            this.btn_add = true

            fetch(this.$store.state.url.TRANSAKSI + "addData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.$q.notify({ type: "positive", message: res_data.message || "Transaksi berhasil ditambahkan" })
                        this.mdl_add = false
                        this.resetForm()
                        this.getView()
                    } else {
                        this.$q.notify({ type: "negative", message: res_data.message || "Gagal menambah transaksi" })
                    }
                })
                .catch(err => {
                    console.error("Error addData:", err)
                    this.$q.notify({ type: "negative", message: "Gagal menambah transaksi darah" })
                })
                .finally(() => {
                    this.btn_add = false
                })
        },

        resetForm() {
            this.form = {
                golongan_darah: '',
                rhesus: '',
                komponen_id: null,
                jumlah: 0,
                tipe_transaksi: '',
                keterangan: ''
            }
        },

        // 🔹 Buka modal edit dan isi data
        openEdit(data) {
            this.form_edit = {
                id_transaksi: data.id_transaksi,
                golongan_darah: data.golongan_darah,
                rhesus: data.rhesus,
                komponen_id: data.komponen_id,
                jumlah: data.jumlah,
                tipe_transaksi: data.tipe_transaksi,
                keterangan: data.keterangan
            };
            this.mdl_edit = true;
        },

        // 🔹 Kirim perubahan ke backend
        editData() {
            this.btn_edit = true;

            fetch(this.$store.state.url.TRANSAKSI + "editData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form_edit)
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.$q.notify({
                            type: "positive",
                            message: res_data.message || "Transaksi darah berhasil diperbarui"
                        });
                        this.mdl_edit = false;
                        this.getView();
                    } else {
                        this.$q.notify({
                            type: "negative",
                            message: res_data.message || "Gagal memperbarui transaksi"
                        });
                    }
                })
                .catch(err => {
                    console.error("Error editData:", err);
                    this.$q.notify({
                        type: "negative",
                        message: "Terjadi kesalahan saat memperbarui data"
                    });
                })
                .finally(() => {
                    this.btn_edit = false;
                });
        },

        // buka modal hapus
        openDelete(data) {
            this.hapus_target = data;
            this.mdl_hapus = true;
        },

        // konfirmasi hapus (panggil backend)
        confirmDelete() {
            if (!this.hapus_target || !this.hapus_target.id_transaksi) {
                this.$q.notify({ type: 'negative', message: 'Tidak ada transaksi yang dipilih' });
                return;
            }

            this.btn_hapus = true;

            fetch(this.$store.state.url.TRANSAKSI + "delete/" + this.hapus_target.id_transaksi, {
                method: "DELETE",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.$q.notify({ type: 'positive', message: res_data.message || 'Transaksi berhasil dihapus' });
                        this.mdl_hapus = false;
                        this.hapus_target = null;
                        // reload current page (tetap di halaman sama)
                        this.getView();
                    } else {
                        this.$q.notify({ type: 'negative', message: res_data.message || 'Gagal menghapus transaksi' });
                    }
                })
                .catch(err => {
                    console.error('Error delete transaksi:', err);
                    this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat menghapus transaksi' });
                })
                .finally(() => {
                    this.btn_hapus = false;
                });
        },



        indexing(idx) {
            return ((this.page_first - 1) * this.page_limit) + idx
        },

        formatTanggal(dt) {
            if (!dt) return '-'
            const d = new Date(dt)
            if (isNaN(d)) return dt
            return d.toLocaleString('id-ID', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        cari_data() {
            this.page_first = 1
            this.getView()
        },

        // 🔹 Terapkan filter
        applyFilter() {
            this.page_first = 1;
            this.getView();
        },
    },

    mounted() {
        this.getKomponen()
        this.getView()
    }
}
